export class TrustAsHtmlHelper {
  static $inject = ["$sce"];
  constructor(protected $sce: ng.ISCEService) {}

  trustAsHtml(content) {
    if (!content) return "";

    // Simple check: if content contains HTML tags, assume it's HTML
    const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(content);

    if (hasHtmlTags) {
      return this.$sce.trustAsHtml(content);
    } else {
      const escapedText = content
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\n/g, "<br/>");
      return this.$sce.trustAsHtml(escapedText);
    }
  }
}
